import { render, staticRenderFns } from "./OrganizMarketQuestionList.vue?vue&type=template&id=41e58517&scoped=true&"
import script from "./OrganizMarketQuestionList.vue?vue&type=script&scoped=true&lang=js&"
export * from "./OrganizMarketQuestionList.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./OrganizMarketQuestionList.vue?vue&type=style&index=0&id=41e58517&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e58517",
  null
  
)

export default component.exports